class PropertyListComponent {
    constructor(propertyListComponent) {
        if (!(propertyListComponent instanceof HTMLElement)) {
            throw new TypeError("The element must be an HTML element.");
        }
        
        this.propertyListComponent = propertyListComponent;
        // get the parent container element (outermost Div in the BE properties view)
        this.propertiesComponent = this.propertyListComponent.parentElement;

        // get data from hidden input fields
        this.numberPerPage = this.propertiesComponent.querySelector('.num-per-page').value;   
        this.dataSourcePageId = this.propertiesComponent.querySelector('.data-source-page-id').value;
        this.restMessageSuccess = this.propertiesComponent.querySelector('.rest-message--success').value;
        this.restMessageFail = this.propertiesComponent.querySelector('.rest-message--fail').value;
    }
    init() {
        APIUtils.getComponentData(this.propertyListComponent, 
            `${APIPrefix.get()}/search_api/properties?noOfItemsPerPage=${this.numberPerPage}&dataSourcePageId=${this.dataSourcePageId}`,
            this.restMessageSuccess,
            this.restMessageFail
        ).then( (response) => {
            let propertyData = response.data;
            let propertyTable = new PropertyTable( this.propertyListComponent);
            propertyTable.populateTable(propertyData);
        });
    }
}

// Check for Property List components when the document has loaded and initialise if we have any 
document.addEventListener("DOMContentLoaded", function () {
    const propertyListComponents = document.querySelectorAll('.property-list-component');
    if (propertyListComponents.length) {
        propertyListComponents.forEach(function(component) {
            let propertyListComponent = new PropertyListComponent(component);
            propertyListComponent.init();
        });
    }
});